import React from 'react';
import TimePicker from "react-times";
import {CTimerPickerWrapper, TimePickerIconWrapper} from "./input.styles";

const CustomTimePicker = ({label, id, labelStyle, ...otherProps}) => {
    return (
        <CTimerPickerWrapper>
            <label className={labelStyle ? labelStyle : 'd-block text-end mb-2'} htmlFor={id}>{label}</label>
            <TimePickerIconWrapper>
                <i className='icon-clock' />
            </TimePickerIconWrapper>
            <TimePicker {...otherProps} />
        </CTimerPickerWrapper>
    );
};

export default CustomTimePicker;
